import styles from "../styles/customerStyles.module.css";

export function getDisputeStatusDesign(params) {
    if (params.value === "Completed") {
      return (
        <div
          style={{
            background: "rgba(145, 85, 253, 0.25)",
          }}
          className={styles.fulfillment}
        >
          {params.value}
        </div>
      );
    }
    else {
      return (
        <div
          style={{
            background: "rgba(102, 155, 244, 0.29)",
          }}
          className={styles.fulfillment}
        >
          {params.value}
        </div>
      );
    }
  }